import initialState from './initialState';
import { GET_FAVORITES } from '../constants';

export default (state = initialState.favorites, action) => {
  switch (action.type) {
    case GET_FAVORITES:
      return {
        ...state,
        ...action.response,
      };

    default:
      return state;
  }
};
